import {cloneDeep as _cloneDeep} from 'lodash';
import LandPurposesModel from "./../../models/LandPurposesModel"
const LandPurposesModule = {
    namespaced: true,
    state: () => ({
        landPurposes: [],
        landPurpose: _cloneDeep(LandPurposesModel, true),
    }),
    getters: {
        getLandPurposes (state) {
            return state.landPurposes
        },
        getLandPurpose (state) {
            return state.landPurpose
        },
    },
    mutations: {
        setLandPurposes (state, payload) {
            state.landPurposes = payload
        },
        setLandPurpose (state, payload) {
            state.landPurpose = payload
        },
    },
    actions: {
        setLandPurposes (context, payload) {
            context.commit('setLandPurposes', payload);
        },
        setLandPurpose (context, payload) {
            context.commit('setLandPurpose', payload);
        },
    },

}

export default LandPurposesModule;
